export default __webpack_public_path__ + "static/media/Creative3.3a971694.png";